import React from 'react';
import IconButtonActions from '../../DataTable/IconButtonActions';
import { CustomColumn } from '../../../types/customColumn';

interface TableBodyProps {
  table: any;
  actions?: any;
  noDataMessage?: string;
}

const TableBody: React.FC<TableBodyProps> = ({ table, actions, noDataMessage }) => {
  const { getTableBodyProps, page, prepareRow, columns } = table;

  return (
    <tbody {...getTableBodyProps()}>
      {page.length > 0 ? (
        page.map((row: any) => {
          prepareRow(row);
          return (
            <tr
              {...row.getRowProps()}
              className="dark:border-gray-700 hover:bg-gray-50 transition dark:hover:bg-graydark/40"
            >
              {row.cells.map((cell: any) => {
                const column = cell.column as CustomColumn<object>;
                return (
                  <td
                    {...cell.getCellProps()}
                    className="text-gray-900 dark:text-gray-200 px-4 py-4 text-[15px] leading-relaxed"
                  >
                    {'customCell' in column && column.customCell
                      ? column.customCell(cell)
                      : cell.render('Cell')}
                  </td>
                );
              })}

              {actions && (
                <td className="px-4 py-4 text-center">
                  <div className="flex justify-center">
                    <IconButtonActions actions={actions} row={row.original} />
                  </div>
                </td>
              )}
            </tr>
          );
        })
      ) : (
        <tr className="bg-white dark:bg-boxdark">
          <td
            colSpan={columns.length + (actions ? 1 : 0)}
            className="px-6 py-8 text-center text-gray-500 dark:text-gray-400 text-base"
          >
            {noDataMessage || 'No hay datos disponibles.'}
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default TableBody;
